import { show } from "@ebay/nice-modal-react";
import { canv } from "@/canv/global";
import { PresentationWidget } from "@/elements/Presentation/Presentation";
import { PlayIcon } from "@/icons";
import { BuyProModal } from "@/interface/ui/modals/BuyProModal";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UsePresentationPlayButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function usePresentationPlayButton({
    setActiveSubMenu,
}: UsePresentationPlayButtonProps): MenuOptionResult {
    const handleClick = () => {
        setActiveSubMenu(null);

        if (!canv.getInitDataProp("isProfessional")) {
            show(BuyProModal, { feature: "presentation" });
            return;
        }

        const selectedEntities = canv.canvasController.selected;
        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild();
            if (child && child instanceof PresentationWidget) {
                child.play();
            }
        }
    };

    return {
        content: <PlayIcon />,
        handleClick,
    };
}
